import { isRegisterApi } from "@/api/auth-api";
import { doGoogleLogin } from "@/utils/google-auth";
import { useSignal } from "@preact-signals/safe-react";
import { GoogleLogin, GoogleOAuthProvider } from "@react-oauth/google";
import { Dropdown, DropdownRef, Toast } from "antd-mobile";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { getText } from "../../../../utils/util";
import "./index.css";

const GOOGLE_CLIENT_ID =
  "39845133901-f402t02cq4922s5tf80vkvc17c0kcj6r.apps.googleusercontent.com";

export default function PageRegister({
  doRegister,
  areas,
  sendSMS,
  show60,
  setShow60,
  companyData,
  registerMsg,
}) {
  const navigate = useNavigate();
  const { code } = useParams();
  const { t: translate } = useTranslation();
  const { t, i18n } = useTranslation();
  const [isPhone, setIsPhone] = useState(false);
  const [area, setArea] = useState({} as any);
  const [passwordType1, setPasswordType1] = useState(true);
  const [passwordType2, setPasswordType2] = useState(true);
  const [passwordType3, setPasswordType3] = useState(true);
  const [passwordType4, setPasswordType4] = useState(true);
  const dropdownRef = useRef<DropdownRef>();
  const [time, setTime] = useState(60);
  const lan = localStorage.getItem("i18n");
  const appStatus = localStorage.getItem("appStatus");
  let timeTemp = 60;
  let timer;

  //发送数据
  const [sendData, setSendData] = useState({
    type: 2,
    username: "",
    password: "",
    repassword: "",
    regcode: "",
    invit: "",
    area: areas[0],
  });
  //切换选项
  const changeType = (type: number) => {
    setSendData({
      type: type,
      username: "",
      password: "",
      repassword: "",
      regcode: "",
      invit: code || "",
      area: areas[0],
    });
  };

  //修改数据
  const updateSendData = (e) => {
    const name = e.target.name;
    setSendData({
      ...sendData,
      [name]: e.target.value,
    });
  };

  useEffect(() => {
    setArea(areas[0]);
  }, [areas]);

  useEffect(() => {
    if (code) {
      setSendData((prev) => ({
        ...prev,
        invit: code,
      }));
    }
  }, [code]);

  useEffect(() => {
    if (show60) {
      timer = setInterval(() => {
        if (timeTemp <= 1) {
          timeTemp = 60;
        }
        timeTemp = timeTemp - 1;
        setTime(timeTemp);
        if (timeTemp === 1) {
          setShow60(false);
          clearInterval(timer);
        }
      }, 1000);
    }

    return () => {
      // clearInterval(timer);
      // setShow60(false);
    };
  }, [show60]);

  // google
  const [showInviteModal, setShowInviteModal] = useState(false);
  const [invit, setInvit] = useState("");

  const handleGoogleButtonClick = () => {
    if (googleLoginRef.current) {
      const button = googleLoginRef.current.querySelector('div[role="button"]');
      if (button) {
        (button as HTMLElement).click();
      }
    }
  };

  const googleLoginRef = useRef<HTMLDivElement>(null);
  const idToken = useSignal("");
  const inviteType = localStorage.getItem("inviteType");

  const handleGoogleLoginSuccess = async (credentialResponse: any) => {
    idToken.value = credentialResponse.credential;
    if (inviteType !== "1") {
      doGoogleLogin({
        idToken: credentialResponse.credential,
        translate: t,
      });
      return;
    }
    const res = await isRegisterApi({ idToken: idToken.value });
    if (res.data) {
      doGoogleLogin({
        idToken: idToken.value,
        translate: translate,
      });
    } else {
      setShowInviteModal(true);
    }
    // if (showInviteModal && !invit) {
    //   Toast.show(t('请输入邀请码'));
    //   return;
    // }

    // doGoogleLogin({
    //   idToken: credentialResponse.credential,
    //   translate: t,
    //   invit: invit,
    // });

    // // 关闭弹窗并重置状态
    // setShowInviteModal(false);
    // setInvit('');
  };

  const handleGoogleLoginError = () => {
    Toast.show("Google auth error");
  };

  return (
    <div className="flex-1 flex flex-col items-center py-6 px-4">
      <div className="w-full max-w-md mx-auto">
        {showInviteModal ? (
          <div className="flex flex-col gap-6 p-4 w-full">
            <div className="flex flex-col gap-2">
              <label
                htmlFor="modal-invite-code"
                className="text-gray-700 text-sm"
              >
                {t("请输入邀请码")}
              </label>
              <input
                id="modal-invite-code"
                type="text"
                placeholder={t("请输入邀请码")}
                className="  text-gray-700 placeholder-gray-400 rounded-md px-4 py-3 !border border-gray-700 ring-1 ring-gray-700 focus:border-gradient-primary focus:ring-2 focus:ring-gradient-primary"
                value={invit}
                onChange={(e) => {
                  setInvit(e.target.value);
                }}
              />
            </div>
            {/* 取消按钮，透明背景，白色文字 */}
            <button
              type="button"
              onClick={() => {
                setShowInviteModal(false);
                setInvit("");
              }}
              className="
      rounded-md transition-colors duration-200
      focus:outline-none focus:ring-2 focus:ring-offset-2
      px-4 py-2 text-base
      bg-transparent text-gray-700
      hover:bg-gray-200
      focus:ring-gray-700
      w-full leading-6 tracking-[-0.2px] font-bold text-center
      border border-gray-700
      flex items-center justify-center gap-2 h-[42px]
    "
            >
              {t("取消")}
            </button>
            {/* 确认按钮，绿色背景，白色文字 */}
            <button
              type="button"
              onClick={() => {
                if (invit) {
                  doGoogleLogin({
                    idToken: idToken.value,
                    translate: t,
                    invit,
                  });

                  // if (googleLoginRef.current) {
                  //   const button =
                  //     googleLoginRef.current.querySelector(
                  //       'div[role="button"]'
                  //     );
                  //   if (button) {
                  //     (button as HTMLElement).click();
                  //   }
                  // }
                } else {
                  Toast.show(t("请输入邀请码"));
                }
              }}
              className="
      font-semibold rounded-md transition-colors duration-200
      focus:outline-none focus:ring-2 focus:ring-offset-2
      px-4 py-2 text-base
      bg-gradient-primary text-white
      hover:bg-gradient-primary
      focus:ring-gradient-primary
      w-full leading-6 tracking-[-0.2px] font-bold text-center
      border border-transparent
      flex items-center justify-center gap-2 h-[42px]
    "
            >
              {t("确认")}
            </button>
          </div>
        ) : (
          <div className="mb-8">
            {/* Tab Switcher */}
            <div className="flex justify-center mb-6">
              <div
                className={`px-4 py-2 rounded-l-lg ${
                  !isPhone
                    ? "bg-primary text-black"
                    : "bg-neutral-800 text-neutral-400"
                } cursor-pointer transition-colors duration-200 text-center text-sm w-32`}
                onClick={() => {
                  setIsPhone(false);
                  setPasswordType1(true);
                  setPasswordType2(true);
                  setPasswordType3(true);
                  setPasswordType4(true);
                  changeType(2);
                }}
              >
                {translate(getText("郵箱註冊"))}
              </div>
              <div
                className={`px-4 py-2 rounded-r-lg ${
                  isPhone
                    ? "bg-primary text-black"
                    : "bg-neutral-800 text-neutral-400"
                } cursor-pointer transition-colors duration-200 text-center text-sm w-32`}
                onClick={() => {
                  setIsPhone(true);
                  setPasswordType1(true);
                  setPasswordType2(true);
                  setPasswordType3(true);
                  setPasswordType4(true);
                  changeType(1);
                }}
              >
                {translate(getText("手機註冊"))}
              </div>
            </div>

            {/* Help button */}
            <div
              className="absolute top-4 right-4 cursor-pointer"
              onClick={() => {
                navigate("/chatcenter");
              }}
            >
              <img src="/img/kf.png" className="w-6 h-6" />
            </div>

            {/* Email Registration Form */}
            {!isPhone && (
              <div className="w-full space-y-4">
                <div className="relative">
                  <input
                    type="text"
                    name="username"
                    value={sendData.username}
                    placeholder={translate(getText("請輸入您的電子郵件"))}
                    onChange={updateSendData}
                    className="w-full bg-neutral-800 border border-neutral-700 rounded-lg px-4 py-3 text-sm text-white focus:outline-none focus:border-primary"
                  />
                </div>

                <div className="flex space-x-2">
                  <input
                    type="text"
                    name="regcode"
                    value={sendData.regcode}
                    placeholder={translate(getText("請輸入驗證碼"))}
                    onChange={updateSendData}
                    className="flex-1 bg-neutral-800 border border-neutral-700 rounded-lg px-4 py-3 text-sm text-white focus:outline-none focus:border-primary"
                  />
                  <button
                    className={`w-32 py-3 rounded-lg text-xs ${
                      show60
                        ? "bg-neutral-700 text-neutral-400"
                        : "bg-primary text-black"
                    }`}
                    onClick={() => {
                      if (show60) {
                        return;
                      }
                      const data = { ...sendData };
                      data.area = area?.internationalAreaCode;
                      sendSMS(data);
                    }}
                  >
                    {!show60 && translate(getText("發送驗證碼"))}
                    {show60 && `${time}s`}
                  </button>
                </div>

                <div className="relative">
                  <input
                    type={passwordType1 ? "password" : "text"}
                    name="password"
                    value={sendData.password}
                    placeholder={translate(getText("請輸入密碼"))}
                    onChange={updateSendData}
                    className="w-full bg-neutral-800 border border-neutral-700 rounded-lg px-4 py-3 text-sm text-white focus:outline-none focus:border-primary"
                  />
                  <div
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
                    onClick={() => {
                      setPasswordType1(!passwordType1);
                    }}
                  >
                    <img
                      src={
                        passwordType1
                          ? "/img/login_btn_eye_close.png"
                          : "/img/login_btn_eye_open.png"
                      }
                      className="w-5 h-5"
                    />
                  </div>
                </div>

                <div className="relative">
                  <input
                    type={passwordType2 ? "password" : "text"}
                    name="repassword"
                    value={sendData.repassword}
                    placeholder={translate(getText("請輸入密碼"))}
                    onChange={updateSendData}
                    className="w-full bg-neutral-800 border border-neutral-700 rounded-lg px-4 py-3 text-sm text-white focus:outline-none focus:border-primary"
                  />
                  <div
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
                    onClick={() => {
                      setPasswordType2(!passwordType2);
                    }}
                  >
                    <img
                      src={
                        passwordType2
                          ? "/img/login_btn_eye_close.png"
                          : "/img/login_btn_eye_open.png"
                      }
                      className="w-5 h-5"
                    />
                  </div>
                </div>

                {inviteType == "1" && (
                  <div className="relative">
                    <input
                      type="text"
                      name="invit"
                      value={sendData.invit}
                      placeholder={translate(getText("請輸入邀請碼"))}
                      onChange={updateSendData}
                      className="w-full bg-neutral-800 border border-neutral-700 rounded-lg px-4 py-3 text-sm text-white focus:outline-none focus:border-primary"
                    />
                  </div>
                )}
              </div>
            )}

            {/* Phone Registration Form */}
            {isPhone && (
              <div className="w-full space-y-4">
                <div className="flex">
                  <div className="w-24 mr-2">
                    <Dropdown
                      ref={dropdownRef}
                      closeOnClickAway={true}
                      className="h-12 bg-transparent"
                    >
                      <Dropdown.Item
                        key="sorter"
                        title={`+ ${area && area?.internationalAreaCode}`}
                        className="revert-style bg-neutral-800 border border-neutral-700 rounded-lg px-2 py-3 text-sm h-12"
                      >
                        <div className="h-64 overflow-y-auto text-neutral-200  bg-neutral-900 p-2">
                          {areas.map((data) => (
                            <div
                              key={data.id}
                              onClick={() => {
                                setArea(data);
                                dropdownRef.current?.close();
                              }}
                              className="py-3 px-4 flex justify-between items-center cursor-pointer hover:bg-neutral-700 border-b"
                            >
                              {localStorage.getItem("i18n") == "zh"
                                ? data.nameZh
                                : data.nameEn}
                              <span className="float-right">
                                +{data.internationalAreaCode}
                              </span>
                              {/* <Divider className="my-1 bg-neutral-700" /> */}
                            </div>
                          ))}
                        </div>
                      </Dropdown.Item>
                    </Dropdown>
                  </div>
                  <input
                    type="text"
                    name="username"
                    value={sendData.username}
                    placeholder={translate(getText("請輸入電話號碼"))}
                    onChange={updateSendData}
                    className="flex-1 bg-neutral-800 border border-neutral-700 rounded-lg px-4 py-3 text-sm text-white focus:outline-none focus:border-primary"
                  />
                </div>

                <div className="flex space-x-2">
                  <input
                    type="text"
                    name="regcode"
                    value={sendData.regcode}
                    placeholder={translate(getText("請輸入驗證碼"))}
                    onChange={updateSendData}
                    className="flex-1 bg-neutral-800 border border-neutral-700 rounded-lg px-4 py-3 text-sm text-white focus:outline-none focus:border-primary"
                  />
                  <button
                    className={`w-32 py-3 rounded-lg text-xs ${
                      show60
                        ? "bg-neutral-700 text-neutral-400"
                        : "bg-primary text-black"
                    }`}
                    onClick={() => {
                      if (show60) {
                        return;
                      }
                      const data = { ...sendData };
                      if (data.type === 1) {
                        data.area = area?.internationalAreaCode;
                      }
                      sendSMS(data);
                    }}
                  >
                    {!show60 && translate(getText("發送驗證碼"))}
                    {show60 && `${time}s`}
                  </button>
                </div>

                <div className="relative">
                  <input
                    type={passwordType3 ? "password" : "text"}
                    name="password"
                    value={sendData.password}
                    placeholder={translate(getText("請輸入密碼"))}
                    onChange={updateSendData}
                    className="w-full bg-neutral-800 border border-neutral-700 rounded-lg px-4 py-3 text-sm text-white focus:outline-none focus:border-primary"
                  />
                  <div
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
                    onClick={() => {
                      setPasswordType3(!passwordType3);
                    }}
                  >
                    <img
                      src={
                        passwordType3
                          ? "/img/login_btn_eye_close.png"
                          : "/img/login_btn_eye_open.png"
                      }
                      className="w-5 h-5"
                    />
                  </div>
                </div>

                <div className="relative">
                  <input
                    type={passwordType4 ? "password" : "text"}
                    name="repassword"
                    value={sendData.repassword}
                    placeholder={translate(getText("請輸入密碼"))}
                    onChange={updateSendData}
                    className="w-full bg-neutral-800 border border-neutral-700 rounded-lg px-4 py-3 text-sm text-white focus:outline-none focus:border-primary"
                  />
                  <div
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
                    onClick={() => {
                      setPasswordType4(!passwordType4);
                    }}
                  >
                    <img
                      src={
                        passwordType4
                          ? "/img/login_btn_eye_close.png"
                          : "/img/login_btn_eye_open.png"
                      }
                      className="w-5 h-5"
                    />
                  </div>
                </div>

                {inviteType == "1" && (
                  <div className="relative">
                    <input
                      type="text"
                      name="invit"
                      value={sendData.invit}
                      placeholder={translate(getText("請輸入邀請碼"))}
                      onChange={updateSendData}
                      className="w-full bg-neutral-800 border border-neutral-700 rounded-lg px-4 py-3 text-sm text-white focus:outline-none focus:border-primary"
                    />
                  </div>
                )}
              </div>
            )}

            {/* Submit Buttons and Message */}
            <div className="mt-6">
              {registerMsg && (
                <div className="text-center text-sm text-danger mb-4">
                  {registerMsg}
                </div>
              )}

              <button
                className={`w-full bg-gradient-primary text-black py-3 rounded-lg font-medium mb-4 transition-all hover:opacity-90 active:scale-98`}
                onClick={() => {
                  const data = { ...sendData };
                  if (data.type === 1) {
                    data.area = area?.internationalAreaCode;
                  }
                  doRegister(data);
                }}
              >
                {translate(getText("立即註冊"))}
              </button>

              <button
                type="button"
                onClick={handleGoogleButtonClick}
                className="mb-2 transition-colors duration-200 px-4 py-2 text-base bg-transparent hover:bg-gray-200 w-full text-base leading-6 tracking-[-0.2px] font-bold text-center border border-gray-700 flex items-center justify-center gap-2 h-[42px] rounded-lg"
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.64 9.20454C17.64 8.56636 17.5827 7.95272 17.4764 7.36363H9V10.8444H13.8436C13.635 11.9699 13.0009 12.9231 12.0477 13.5613V15.8194H14.9564C16.6582 14.2526 17.64 11.9453 17.64 9.20454Z"
                    fill="#4285F4"
                  />
                  <path
                    d="M9 18C11.43 18 13.4673 17.1941 14.9564 15.8195L12.0477 13.5613C11.2418 14.1013 10.2109 14.4204 9 14.4204C6.65591 14.4204 4.67182 12.8372 3.96409 10.71H0.957275V13.0418C2.43818 15.9831 5.48182 18 9 18Z"
                    fill="#34A853"
                  />
                  <path
                    d="M3.96409 10.7099C3.78409 10.1699 3.68182 9.59307 3.68182 8.99989C3.68182 8.40671 3.78409 7.82989 3.96409 7.28989V4.95807H0.957273C0.347727 6.17353 0 7.54807 0 8.99989C0 10.4517 0.347727 11.8263 0.957273 13.0417L3.96409 10.7099Z"
                    fill="#FBBC05"
                  />
                  <path
                    d="M9 3.57955C10.3214 3.57955 11.5077 4.03364 12.4405 4.92545L15.0218 2.34409C13.4632 0.891818 11.4259 0 9 0C5.48182 0 2.43818 2.01682 0.957275 4.95818L3.96409 7.29C4.67182 5.16273 6.65591 3.57955 9 3.57955Z"
                    fill="#EA4335"
                  />
                </svg>
                {t("login.sign_in_with_google")}
              </button>

              <div className="flex justify-between items-center text-sm">
                <button
                  className="text-primary"
                  onClick={() => {
                    navigate("/login");
                  }}
                >
                  {translate(getText("登錄"))}
                </button>

                {appStatus === "1" && (
                  <button
                    className="text-primary"
                    onClick={() => {
                      navigate("/download");
                    }}
                  >
                    App{(lan == "zh" ? "" : " ") + translate(getText("下載"))}
                  </button>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="invisible h-0 w-0 absolute">
        {/* Google OAuth Provider 和按钮 */}
        <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
          <div
            ref={googleLoginRef}
            className="invisible flex w-full justify-center"
          >
            <GoogleLogin
              theme="outline"
              locale={i18n.language}
              size="medium"
              onSuccess={handleGoogleLoginSuccess}
              onError={handleGoogleLoginError}
            />
          </div>
        </GoogleOAuthProvider>
      </div>
    </div>
  );
}
